import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { MediaCategory } from 'src/app/models/media/media-category.model';
import { MediaGroup } from 'src/app/models/media/media-group.model';
import { ViewMode } from 'src/app/shared-new/enums/view-mode.emun';
import { ImageModalComponent } from '../../image-modal/image-modal.component';

@Component({
  selector: 'app-missing-xrays',
  templateUrl: './missing-xrays.component.html',
  styleUrls: ['./missing-xrays.component.scss'],
})
export class MissingXraysComponent implements OnChanges {
  @Input() expectedMatchedFiles: number = 0;
  @Input() studyFiles: StudyFile[] = [];
  @Input() mediaGroups: MediaGroup[] = [];
  @Input() mediaCategories: MediaCategory[] = [];
  @Input() viewMode: ViewMode = ViewMode.DRAFT;

  ViewMode = ViewMode;
  @Output() changeMediaCategory: EventEmitter<{
    studyFile: StudyFile;
    mediaCategoryId: number;
  }> = new EventEmitter<{ studyFile: StudyFile; mediaCategoryId: number }>();
  @Output() uploadAsAdditional: EventEmitter<{
    studyFile: StudyFile;
    isAdditional: boolean;
  }> = new EventEmitter<{ studyFile: StudyFile; isAdditional: boolean }>();
  @Output() deleteStudyFile: EventEmitter<number> = new EventEmitter<number>();
  @Output() createStudyFile: EventEmitter<{
    file: File;
    mediaCategoryId: number;
  }> = new EventEmitter<{ file: File; mediaCategoryId: number }>();
  @Output() updateStudyFileStatus: EventEmitter<{
    studyFileId: number;
    statusId: number;
    reason: string;
  }> = new EventEmitter<{
    studyFileId: number;
    statusId: number;
    reason: string;
  }>();

  selectedFiles: {
    file: File;
    categoryId: number;
  }[] = [];

  constructor(private modalService: NgbModal) {}

  ngOnChanges(changes: SimpleChanges): void {
    const studyFilesNew = changes['studyFiles'];
    if (
      studyFilesNew?.currentValue &&
      studyFilesNew?.currentValue?.length !==
        studyFilesNew?.previousValue?.length
    ) {
      this.selectedFiles.splice(0, 1);
    }
  }

  emitChangeMediaCategory(model: {
    studyFile: StudyFile;
    mediaCategoryId: number;
  }): void {
    this.changeMediaCategory.emit(model);
  }

  emitUploadAsAdditional(model: {
    studyFile: StudyFile;
    isAdditional: boolean;
  }): void {
    this.uploadAsAdditional.emit(model);
  }

  emitDeleteStudyFile(studyFileId: number): void {
    this.deleteStudyFile.emit(studyFileId);
  }

  uploadFiles(event: { file: File; mediaCategoryId: number }): void {
    const model = {
      file: event.file,
      categoryId: event.mediaCategoryId,
    };
    this.selectedFiles = [model];
    this.createStudyFile.emit({
      file: event.file,
      mediaCategoryId: event.mediaCategoryId,
    });
  }

  checkForCategoryIdUpload(id: number): boolean {
    return !!this.selectedFiles.find((sf) => sf.categoryId === id);
  }

  emitUpdateStatus(event: {
    studyFileId: number;
    statusId: number;
    reason: string;
  }): void {
    this.updateStudyFileStatus.emit(event);
  }

  trackByGroup(index: number, el: MediaGroup): number {
    return el.id;
  }

  trackByCategory(index: number, el: any): number {
    return el?.category?.id;
  }

  trackByStudyFile(index: number, el: StudyFile): number {
    return el.studyFileId;
  }

  viewImage(data: { url: string; studyFileId: number }): void {
    const studyFile: StudyFile = this.studyFiles.filter(
      (x) => x.studyFileId === data.studyFileId
    )[0];
    //this.activityStart.emit({ studyFile, activityId: Activity.XRayView })
    const modalRef = this.modalService.open(ImageModalComponent, {
      size: '75-width',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.url = data.url;
    modalRef.componentInstance.studyFile = studyFile;
    modalRef.result.then(
      (result) => {
        //this.activityEnd.emit(Activity.XRayView);
      },
      (reason) => {
        //this.activityEnd.emit(Activity.XRayView);
      }
    );
  }
}
